import React from 'react';
import Table from 'reactstrap/lib/Table';
import classnames from 'classnames';

import './appraisal-promotions-why-edmunds.scss';

const HEADERS = ['Features', 'Selling Privately', 'Edmunds'];

const FEATURES = [
  'Fair appraisal based on local transactions',
  'See offers in as little as 2 minutes',
  'Real offer from a real dealership',
  'No-obligation offer good for 7 days',
  'No constant haggling',
  'Help with paperwork',
  'Receive a check you can be confident in',
];

export const AppraisalPromotionsWhyEdmunds = () => {
  return (
    <div className="appraisal-promotions-why-edmunds">
      <h2 className="main-header size-36 fw-medium text-cool-gray-10 mb-2 text-center">Why Edmunds</h2>
      <div className="w-100 pos-r">
        <div className="table-background pos-a w-100 h-100 bg-white overflow-hidden">
          <div className="header-background w-100" />
        </div>
        <Table className="w-100 pos-r size-16 bg-transparent mb-0 px-0_5 px-md-1_5 pb-1_5">
          <thead>
            <tr>
              {HEADERS.map((header, index) => (
                <th
                  key={header}
                  className={classnames('text-white pt-sm-1_5 pb-sm-1 border-0 align-middle', {
                    'ps-0_5 ps-md-1_5': index === 0,
                    'ps-0': index === 1,
                    'pe-0_25 pe-md-0': index === 2,
                  })}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {FEATURES.map(feature => (
              <tr key={feature}>
                <td className="text-cool-gray-30 ps-0_5 ps-md-1_5 pe-0 pe-md-0_75 py-1">{feature}</td>
                <td className="align-middle ps-1_25 ps-sm-2_5 pt-0_25 pb-0">
                  <span className="icon-cross2 fw-bold size-20 text-cool-gray-50" aria-hidden />
                  <span className="visually-hidden">{feature}: advantage not available when selling privately</span>
                </td>
                <td className="align-middle ps-2_5 pt-0_25 pb-0">
                  <span className="icon-checkmark size-20 d-inline-block" aria-hidden />
                  <span className="visually-hidden">{feature}: advantage when using Edmunds</span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};
